import ApiRequestManagerInstance from '../ApiRequestManager';
import Channel from '../../classes/channel';
import { IChannelAddonRequest } from '../../types/interfaces/channel';
import { store } from '../../store/store';

async function channelsCornerRequest(asset: { corner: string }) {
  const promise = new Promise<Channel[] | null>(async (resolve) => {
    const { channels: storeChannels, user } = store.getState();
    try {
      const response: { data: IChannelAddonRequest[] } =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: user?.isAnonymous ? 'cdnSyncUrl' : 'apiUrl',
            section: 'corners',
            type: user?.isAnonymous ? 'channelsFree' : 'channels',
            replacement: asset.corner,
          },
        })) as unknown as { data: IChannelAddonRequest[] };
      const channels: Channel[] = response.data.map((remoteCh) => {
        return new Channel({ ...remoteCh, master: remoteCh });
      });
      let finalChannels = channels;
      finalChannels = finalChannels.sort((ch1, ch2) => {
        const index1 = storeChannels.channelsData?.findIndex(
          (ch) => ch1.id === ch.id
        );
        const index2 = storeChannels.channelsData?.findIndex(
          (ch) => ch2.id === ch.id
        );
        return (index1 || 0) < (index2 || 0) ? 1 : -1;
      });
      resolve(finalChannels);
    } catch (e) {
      resolve(null);
    }
  });
  return promise;
}

export default channelsCornerRequest;
